package games.mythical.saga.watcher.sagawatcher.model

@kotlinx.serialization.Serializable
data class GHSession(
    val id: String,
    val clientId: String,
    val patEnabled: Boolean
)